import { TDay } from 'helpers/shiftHelpers/types'

// This is the maximum pay rate value that BND accepts. Greater than 35 throws a 422 error
export const MAX_PAY_RATE_ALLOWED = 35

export const DAYS_PER_PAGE = 7

/**
 * Updates a specific day in the days array and returns a new array
 * @param days Days array in formik
 * @param id Id of the specific day in the array
 * @param day Partial object from the new day
 */
export const updateSpecificDay = (
  days: TDay[],
  id: number,
  day: Partial<TDay>,
) => {
  const dayIndex = days.findIndex(day => day.id === id)
  const newDays = [...days]

  newDays[dayIndex] = {
    ...days[dayIndex],
    ...day,
  }

  return newDays
}

/**
 * Given an array of days, this function transforms the array to array of arrays where each row
 * represents one page data - {DAYS_PER_PAGE} items per page
 * @param days Days array
 */
export const getPaginatedDays = (days: TDay[]) => {
  const paginatedDays = []
  for (let i = 0; i < days.length; i += DAYS_PER_PAGE) {
    const page = days.slice(i, i + DAYS_PER_PAGE)
    paginatedDays.push(page)
  }

  return paginatedDays
}
